import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import WindowBrowser from "../components/browser-window";

import Scrollspy from 'react-scrollspy';

const Safety = () => {
  useEffect(() => {


  }, [])

  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Safety</h1>
        <h3>Spot the fake. Safeguard the cure.</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Overview
            </div>
            <Scrollspy
              offset={-140}

              className="scrollspy" items={['Project_Safety_Form', 'Safety_Training', 'Risk_Management', 'Handling_Hazardous_Chemicals', 'Safe_Waste_Management', 'Compliance', 'Contact']}

              // className="scrollspy" items={['Project Safety Form', 'Project']}
              currentClassName="active">
              <li><a href="#Project_Safety_Form">Project Safety Form</a></li>
              <li><a href="#Safety_Training">Safety Training</a></li>
              <li><a href="#Risk_Management">Risk Management</a></li>
              <li><a href="#Handling_Hazardous_Chemicals">Handling Hazardous Chemicals</a></li>
              <li><a href="#Safe_Waste_Management">Safe Waste Management</a></li>
              <li><a href="#Compliance">Compliance</a></li>
              <li><a href="#Contact">Contact</a></li>
            </Scrollspy>
            <img
              src="https://static.igem.wiki/teams/5334/wiki-images/mascot/mascot-bevatech-1.png"
              alt="Mascot in a hoodie"
              
            />
          </div>

        </div>
        <div className="main_lab_style">
          <WindowBrowser header="Overview" description={
            <div>

              {/* <h1>Overview</h1> */}
              <p>
                Our team is committed to ensuring the highest standards of safety and security in all our research activities. We adhere to the guidelines set by iGEM to manage and mitigate any risks associated with our project.
              </p>
              <section id="Project_Safety_Form">

                <h1>
                  Project Safety Form
                </h1>

                <p>
                  We have submitted our <a href="https://teams.igem.org/5334/safety/1667d143-1b52-491a-9d32-4bd576d4df5b">Project Safety Form</a>, detailing all aspects of our project, including:
                </p>
                <ul>
                  <li><strong>Team Contact Information: </strong>Key contacts for safety-related inquiries.</li>
                  <li><strong>Lab Information: </strong>Details about our lab facilities and safety protocols.</li>
                  <li><strong>Project Description: </strong>Comprehensive overview of our project and its objectives.</li>
                  <li><strong>Risk Assessment: </strong>Identification and management of potential risks to team members, the public, and the environment.</li>
                </ul>

              </section>
              <section id="Safety_Training">

                <h1>
                  Safety Training
                </h1>

                <p>
                  All team members undergo rigorous safety training in accordance with <a href="https://www.cityu.edu.hk/vpre/lsu/chemical-safety.htm">CityU Policies and Guidelines and Hong Kong Legislation</a>, covering:
                </p>
                <ul>
                  <li><strong>Lab Safety Protocols: </strong>Proper use of lab equipment, handling of chemicals, and emergency procedures.</li>
                  <li><strong>Biosafety: </strong>Safe handling of biological materials and organisms.</li>
                  <li><strong>Biosecurity: </strong>Measures to prevent misuse of biological research.</li>
                  <li><strong>Dual-Use Aspects: </strong>Understanding the potential dual-use nature of biological research, where scientific work intended for beneficial purposes could be misapplied for harmful purposes. Training includes recognizing dual-use concerns and implementing strategies to mitigate risks.</li>
                </ul>

              </section>
              <section id="Risk_Management">
                <h1>
                  Risk Management
                </h1>
                <ul>
                  <li><strong>Biosafety Level: </strong>
                    Our lab operates at Biosafety Level 1, dealing with non-pathogenic microbes and offering low health concerns. Lab personnel must follow basic microbiological standards, such as appropriate labeling and waste disposal. Lab coats and gloves are required to reduce exposure. Fundamental laboratory safety standards are taught to ensure all workers are aware of safe biological material handling techniques.
                  </li>
                  <li><strong>Facilities Management: </strong>
                    The Facilities Management Office oversees and advises on the management of dangerous goods stores, chemical waste stores, radioactive waste stores, and liquid nitrogen tanks. They also ensure safety during alterations, additions, improvements, maintenance, and construction works, fire prevention and protection, road management, university vehicle operation, and emergency responses.                  </li>
                </ul>

              </section>
              <section id="Handling_Hazardous_Chemicals">
                <h1>Handling Hazardous Chemicals</h1>
            
                <ul>
                  <li><strong>Fume Hood Usage: </strong>All experiments are conducted under a fully functioning fume hood to reduce the danger of inhaling hazardous chemicals.</li>
                  <li><strong>Spill Kits: </strong>Spill kits tailored to the types of chemicals used in the lab, such as absorbents and neutralizing agents, are maintained.</li>
                  <li><strong>Storage: </strong>Hazardous chemicals are kept in a well-ventilated location.</li>
                </ul>

              </section>

              <section id="Safe_Waste_Management">
                <p><h1>Safe Waste Management</h1></p>
                <p>
                To prevent environmental contamination, dangerous substances and biological samples are disposed of in adequately labeled trash cabinets. In the laboratory, agar gel waste is collected in a yellow biowaste plastic bucket with a capacity of 20 liters, which holds the liquids emitted by the agar gel. Once sealed and properly marked, the pail is placed with other debris and is awaiting pickup by EPS Environmental Protection Technicians.
                </p>
              </section>
              <section id="Compliance">
                <h1>
                  Compliance
                </h1>
                <p>
                We comply with all iGEM competition rules and policies, including:
                </p>
                <ul>
                  <li><strong>Regular Updates: </strong>Providing iGEM HQ with regular updates on our safety practices.</li>
                  <li><strong>Deadlines: </strong>Meeting all deadlines for safety form submissions.</li>
                  <li><strong>Responsible Conduct: </strong>Adhering to ethical guidelines and maintaining a safe research environment.</li>
                </ul>

              </section>

              <br></br>
              <br></br>
              <section id="Contact">
                <h2 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Contact
                </h2>
                <p>
                Following iGEM policy, the PI is responsible for the safety of each participant. For any safety-related inquiries, please contact our PI at <a href="mailto:mbabak@cityu.edu.hk">mbabak@cityu.edu.hk</a>.
                </p>
                <br />
{/* 
                <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Risk management

                </h3>
                <p>
                  The Biosafety level of the lab is level 2 (moderate containment lab) which works with pathogens, and infectious organisms and poses a
                  moderate health hazard.
                  <b>To ensure a safe lab environment </b>, lab members are required to wear
                  PPE with face shields. In addition, the use of biological safety cabinets
                  (BSC) will be trained to handle hazardous biological samples.
                </p>
                <br />
                <h3 style={{ fontFamily: '"Quicksand Bold"', textAlign: 'center', color: '#0D4B5E', fontSize: 25, padding: '10px 50px' }}>
                  To ensure safe project design,
                  we have adopted the following safety measures:
                </h3>
                <br />

                <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Risk management
                </h3>
                <p>
                  The departmental safety officer is consulted and the
                  departmental biological protection officer is approached if a
                  hazard or risk is detected. Also, biosafety measures such as
                  accident reporting, and wearing PPE are implemented beforehand
                  to manage project risks properly and quickly.
                </p>
                <br />

                <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Safety training
                </h3>
                <p>
                  Required safety training is provided by the departmental safety
                  officer who is responsible for reducing the risk in our project. Prior
                  to doing project lab work, all team members should undergo safety
                  training,
                  in which content includes lab access, biosafety equipment,
                  personnel biosafety, etc.
                </p>
                <br />

                <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Handling hazardous chemicals
                </h3>
                <p>
                  Hazardous chemicals used in the project: ethyl acetate, ethanol,
                  DMSO, cremophor, MTT, formic acid, acetonitrile & methanol.
                  <br />

                  As they are hazardous, we implement the following safety measures:
                  <ol>
                    <li>
                      Hazardous chemicals are stored in a well-ventilated area
                    </li>
                    <li>
                      Protective gloves, safety googles and face shields are worn
                    </li>
                    <li>
                      Experiments are carried out in fumehood
                    </li>
                  </ol>

                </p>
                <br />


                <h3 style={{ padding: '10px 40px', background: '#123051', color: '#FFF', display: 'inline' }}>
                  Safe waste management
                </h3>
                <p>
                  To avoid environmental contamination, hazardous chemicals, and biological samples are disposed to the labelled waste cabinets.
                  The wastes of agar gel are collected in a yellow biowaste plastic 20L
                  pail in the laboratory which contains liquids released by agar gel.
                  After sealing the pail and filling in the tag, the pail is placed beside
                  other waste awaiting removal by EPS Environmental Protection
                  Technicians.
                </p> */}
                <br />
              </section>
            </div>
          } />
        </div>
      </section>
    </div>
  );
}

export default Safety;
